import React, { useState , useEffect} from 'react';

const ClosedTradesTable = ({ 
  closedTrades, 
  fromPreview,
  currentPageClosed, 
  paginateClosed, 
  requestSort, 
  sortConfig, 
  renderSortArrow,
  prevStrategyCode
}) => {
  const [itemsPerPageClosed, setItemsPerPageClosed] = useState(15); // Default items per page
  const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = window.sessionStorage.getItem("jwtToken");

const [strategies, setStrategies] = useState([]);
const [selectedStrategy, setSelectedStrategy] = useState({
  strategyCode: "",
  strategyName: ""
});
const [selectedTrades, setSelectedTrades] = useState([]);
const [showModal, setShowModal] = useState(false);
const [modalMessage, setModalMessage] = useState("");
const [showConfirmModal, setShowConfirmModal] = useState(false);


  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 15);
    setItemsPerPageClosed(newItemsPerPage); // Update local state
    paginateClosed(1); // Reset to the first page
  };

  const indexOfLastClosedTrade = currentPageClosed * itemsPerPageClosed;
  const indexOfFirstClosedTrade = indexOfLastClosedTrade - itemsPerPageClosed;
  const currentClosedTrades = closedTrades.slice(indexOfFirstClosedTrade, indexOfLastClosedTrade);

  const totalPages = Math.ceil(closedTrades.length / itemsPerPageClosed);

  // Helper to generate pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];
    const maxButtons = 5; // Number of pagination buttons to show
    const startPage = Math.max(1, currentPageClosed - Math.floor(maxButtons / 2));
    const endPage = Math.min(totalPages, startPage + maxButtons - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className={`page-item ${currentPageClosed === i ? 'active' : ''}`} key={i}>
          <button className="page-link" onClick={() => paginateClosed(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (startPage > 1) {
      buttons.unshift(
        <li className="page-item" key="start-ellipsis">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (endPage < totalPages) {
      buttons.push(
        <li className="page-item" key="end-ellipsis">
          <span className="page-link">...</span>
        </li>
      );
    }

    return buttons;
  };

  useEffect(() => {
  if (fromPreview) {
    fetch(`${BASE_URL}/user/getAllStrategies`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setStrategies(data))
      .catch(() => setModalMessage("Failed to load strategies"));
  }
}, [fromPreview]);

const handleCheckboxChange = (trade) => {
  setSelectedTrades(prev =>
    prev.includes(trade)
      ? prev.filter(t => t !== trade)
      : [...prev, trade]
  );
};

const confirmAssignStrategy = () => {
  if (!selectedStrategy) {
    setModalMessage("Please select a strategy first.");
    setShowModal(true);
    return;
  }
  if (selectedTrades.length === 0) {
    setModalMessage("Please select at least one trade.");
    setShowModal(true);
    return;
  }
  // ✅ Show confirmation modal
  setShowConfirmModal(true);
};

const handleAssignStrategy = async () => {
  if (!selectedStrategy) {
    setModalMessage("Please select a strategy first.");
    setShowModal(true);
    return;
  }
  if (selectedTrades.length === 0) {
    setModalMessage("Please select at least one trade.");
    setShowModal(true);
    return;
  }

  const payload = {
    strategyCode: selectedStrategy.strategyCode,
    strategyName: selectedStrategy.strategyName,
    prevStrategyCode: prevStrategyCode,
    trades: selectedTrades.map(trade => ({
      stockName: trade.stockName,
      entryPrice: trade.entryPrice,
      exitPrice: trade.exitPrice,
      pnl: trade.pnl,
      entryDate: trade.entryDate,
      exitDate: trade.exitDate,
      quantity: trade.quantity || 0,
      current_price: trade.current_price || 0,
      averageentryprice: trade.averageentryprice || 0,
      iconurl: trade.iconurl || ""
    }))
  };

  try {
    const response = await fetch(`${BASE_URL}/saveLiveFilteredStocks`, {
      method: "POST",
      headers: { "Content-Type": "application/json" , Authorization: `Bearer ${token}`},
      body: JSON.stringify(payload)
    });

    const result = await response.json();
    console.log(result);

    // ✅ Success case
    if (response.ok && Number(result.status?.statusCode) === 200) {
      setModalMessage(result.status?.message || "Trades successfully assigned and removed!");
      setShowModal(true);
      setSelectedTrades([]);
      setSelectedStrategy("");
    } else {
      // ❌ Failure case
      setModalMessage(result.status?.message || "Failed to assign trades.");
      setShowModal(true);
    }
  } catch (error) {
    console.error("Error assigning trades:", error);
    setModalMessage("Failed to assign trades. Please try again.");
    setShowModal(true);
  }
};

const handleConfirmYes = () => {
  setShowConfirmModal(false);
  handleAssignStrategy(); // proceed with your existing logic
};


  return (
    <div className="container-fluid">
      {fromPreview && (
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5>Closed Trades</h5>
          <div className="d-flex align-items-center gap-2">
            <select
                className="form-select"
                value={selectedStrategy.strategyCode}
                onChange={(e) => {
                  const selectedOption = strategies.find(
                    s => s.strategycode === e.target.value
                  );

                  if (!selectedOption) {
                    setSelectedStrategy({ strategyCode: "", strategyName: "" });
                    return;
                  }

                  setSelectedStrategy({
                    strategyCode: selectedOption.strategycode,
                    strategyName: selectedOption.title
                  });
                }}
              >
              <option value="">Select Strategy</option>
              {strategies.map(strategy => (
                <option key={strategy.id} value={strategy.strategycode}>
                  {strategy.title}
                </option>
              ))}
            </select>
            <button className="btn btn-primary" onClick={confirmAssignStrategy}>
              Assign
            </button>
          </div>
        </div>
      )}

      <div className="mb-4">
        <table className="table table-striped table-borderless">
          <thead>
            <tr>
              <th onClick={() => requestSort('stockName')}>
                Stock Name {renderSortArrow('stockName')}
              </th>
              <th>Entry Price</th>
              <th>Exit Price</th>
              <th>PnL</th>
              <th>Entry Date</th>
              <th>Exit Date</th>
              {fromPreview && <th>Select</th>}

            </tr>
          </thead>
          <tbody>
            {currentClosedTrades && currentClosedTrades.length > 0 ? (
              currentClosedTrades.map((trade, index) => (
                <tr key={index}>
                  <td>{trade.stockName}</td>
                  <td>{trade.entryPrice}</td>
                  <td>{trade.exitPrice}</td>
                  <td>{trade.pnl}</td>
                  <td>{trade.entryDate}</td>
                  <td>{trade.exitDate}</td>
                  {fromPreview && (
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedTrades.includes(trade)}
                        onChange={() => handleCheckboxChange(trade)}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">No closed trades available...</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <nav className="d-flex justify-content-center mt-3">
        <ul className="pagination">
          <li className={`page-item ${currentPageClosed === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => paginateClosed(currentPageClosed - 1)}
              disabled={currentPageClosed === 1}
            >
              Previous
            </button>
          </li>
          {renderPaginationButtons()}
          <li className={`page-item ${currentPageClosed === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => paginateClosed(currentPageClosed + 1)}
              disabled={currentPageClosed === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
        {/* Items per Page Selector */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <ul>
            Show{' '}
            <select
              value={itemsPerPageClosed}
              onChange={handleItemsPerPageChange}
              className="form-select d-inline-block w-auto"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>{' '}
            entries
          </ul>
        </div>
      </nav> 
       {showConfirmModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Action</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowConfirmModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to assign stock?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowConfirmModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleConfirmYes}
                >
                  Yes, Assign
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClosedTradesTable;
